const actions = (dispatch) => {
  const setFilterState = (filterState) => {
    dispatch({
      type: 'setFilterState',
      filterState
    })
  }
  const setTypeFilter = (typeFilter) => {
    dispatch({
      type: 'setTypeFilter',
      typeFilter
    })
  }
  const setSeasonFilter = (seasonFilter) => {
    dispatch({
      type: 'setSeasonFilter',
      seasonFilter
    })
  }
  const setPeriodFilter = (periodFilter) => {
    dispatch({
      type: 'setPeriodFilter',
      periodFilter
    })
  }
  const setClubsFilter = (clubsFilter) => {
    dispatch({
      type: 'setClubsFilter',
      clubsFilter
    })
  }
  const setTeamsFilter = (teamsFilter) => {
    dispatch({
      type: 'setTeamsFilter',
      teamsFilter
    })
  }
  const setUserFilter = (userFilter) => {
    dispatch({
      type: 'setUserFilter',
      userFilter
    })
  }
  const setFromFilter = (fromFilter) => {
    dispatch({
      type: 'setFromFilter',
      fromFilter
    })
  }
  const setToFilter = (toFilter) => {
    dispatch({
      type: 'setToFilter',
      toFilter
    })
  }
  return {
    setFilterState,
    setTypeFilter,
    setSeasonFilter,
    setPeriodFilter,
    setClubsFilter,
    setTeamsFilter,
    setUserFilter,
    setFromFilter,
    setToFilter
  }
}

export default actions
